import { useQuery } from '@tanstack/react-query';

// mathJS is a pretty big library, even when we slim it down as much as possible, so we lazy load
// where possible to prevent the bundle size from exploding.
export function useFormulaParser({ enabled } = { enabled: false }) {
  const parseFormulaLoader = useQuery(
    ['parseFormula'],
    async () => {
      const { parseFormula } = await import('@/plugin-system/runtime/DataQueriesProvider/formulas/parser/parser');
      return parseFormula;
    },
    {
      enabled: enabled,
    }
  );
  return parseFormulaLoader;
}
